/** Cuantas filas descartadas se listan antes de resumir con «…y N mas». */
const MAX_LISTADAS = 10;

/**
 * Filas del archivo que no entran, con su numero en la hoja y el motivo
 * (Kilo, oct 2026): «faltan filas» sin decir cuales no se puede corregir.
 * `primeraFila` es el numero en la hoja de la primera fila de datos: 2 con
 * cabecera, 1 sin ella.
 */
export function FilasDescartadas({
  filas,
  primeraFila,
  origen,
}: {
  filas: Array<{ row: number; reason: string }>;
  primeraFila: number;
  /** Dónde estaba cada fila de datos en la hoja («fila 12», «columna D»). Manda sobre `primeraFila`. */
  origen?: string[];
}): JSX.Element | null {
  if (filas.length === 0) return null;
  return (
    <li>
      {filas.length} {filas.length === 1 ? 'fila descartada' : 'filas descartadas'}:
      <ul>
        {filas.slice(0, MAX_LISTADAS).map((f) => (
          <li key={f.row}>
            {origen?.[f.row]
              ? origen[f.row]!.charAt(0).toUpperCase() + origen[f.row]!.slice(1)
              : `Fila ${f.row + primeraFila}`}
            : {f.reason}
          </li>
        ))}
        {filas.length > MAX_LISTADAS && <li>…y {filas.length - MAX_LISTADAS} más.</li>}
      </ul>
    </li>
  );
}
